import ReactDOM from 'react-dom'
import loading_img from './loading.svg'
import './index.less'

const prefix = 'loading'
function Loading() {
  return (
    ReactDOM.createPortal(
      <div className={prefix}>
        {/* <span className="loading-img"></span> */}
        <img src={loading_img} className="loading-img2"></img>
        <p>분석 실행 중입니다.</p>
      </div>
      ,
      document.body,
    )
  )
}
export default Loading
